import React from 'react';
import EntitySvgAssetsBlock from '../../svgLibrary/EntitySvgAssetsBlock';

type Props = {
    productId: string;
};

const ProductSvgAssetsBlock = ({ productId }: Props) => (
    <EntitySvgAssetsBlock ownerKind="product" ownerId={productId} />
);

export default ProductSvgAssetsBlock;
